// extracted by mini-css-extract-plugin
module.exports = {"header":"header-1X6t_","buttons":"buttons-377JZ","skipVisaButton":"skipVisaButton-3tSwC"};